import { render, staticRenderFns } from "./invitation-form.vue?vue&type=template&id=c1ce2846&scoped=true"
import script from "./invitation-form.vue?vue&type=script&lang=js"
export * from "./invitation-form.vue?vue&type=script&lang=js"
import style0 from "./invitation-form.vue?vue&type=style&index=0&id=c1ce2846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ce2846",
  null
  
)

export default component.exports